import styled from "styled-components";
import { youtube } from "../../assets";


const YoutubeReview = () => {
      return (
            <StyledYoutubeReview>
                  <div className="container pry-text">
                        <div className="mb-5 text-center">
                              <h3 className="">
                                    Get a detailed review on Reni.finance
                              </h3>
                        </div>

                        <div className="">
                              <img src={youtube} alt="Youtube" width="100%" />
                        </div>
                  </div>
            </StyledYoutubeReview>
      );
};

export default YoutubeReview;


const StyledYoutubeReview = styled.section`

      padding: 4rem 0;
      margin-bottom:4rem;
`;